import { render, staticRenderFns } from "./Penalty.vue?vue&type=template&id=415c48a8&scoped=true&"
import script from "./Penalty.vue?vue&type=script&lang=js&"
export * from "./Penalty.vue?vue&type=script&lang=js&"
import style0 from "./Penalty.vue?vue&type=style&index=0&id=415c48a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415c48a8",
  null
  
)

export default component.exports